import Api from "../apiService";

class FleetVehicleRemarksApi {
  index(companyId, vehicleId, params = {}) {
    return Api.getRequest(
      `companies/${companyId}/vehicles/${vehicleId}/remarks`,
      params,
      Api.authHeaders()
    );
  }

  // name — название пометки, text — её описание.
  create(companyId, vehicleId, data) {
    return Api.postRequest(
      `companies/${companyId}/vehicles/${vehicleId}/remarks`,
      data,
      Api.authHeaders()
    );
  }

  show(companyId, vehicleId, id) {
    return Api.getRequest(
      `companies/${companyId}/vehicles/${vehicleId}/remarks/${id}`,
      {},
      Api.authHeaders()
    );
  }

  update(companyId, vehicleId, id, data) {
    return Api.patchRequest(
      `companies/${companyId}/vehicles/${vehicleId}/remarks/${id}`,
      data,
      Api.authHeaders()
    );
  }

  changeStatus(companyId, vehicleId, id, data) {
    return Api.patchRequest(
      `companies/${companyId}/vehicles/${vehicleId}/remarks/${id}/change_status`,
      data,
      Api.authHeaders()
    );
  }

  archive(companyId, vehicleId, id) {
    return Api.patchRequest(
      `companies/${companyId}/vehicles/${vehicleId}/remarks/${id}/archive`,
      {},
      Api.authHeaders()
    );
  }

  restore(companyId, vehicleId, id) {
    return Api.patchRequest(
      `companies/${companyId}/vehicles/${vehicleId}/remarks/${id}/restore`,
      {},
      Api.authHeaders()
    );
  }
}

export default new FleetVehicleRemarksApi();
